var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResendMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07239 0.587708H11.9916C12.8955 0.587708 13.6593 1.18735 13.907 2.01053L8.80773 5.99437C7.91421 6.69243 6.66278 6.70174 5.75898 6.01704L0.223564 1.82354C0.523741 1.0981 1.23846 0.587708 2.07239 0.587708ZM0.0723877 2.96357V8.58388C0.0723877 9.68845 0.967819 10.5839 2.07239 10.5839H4.44699H8.57409C9.00984 7.98438 11.269 6.00301 13.9916 5.99982V3.21348L9.42338 6.78239C8.17245 7.75968 6.42044 7.77271 5.15512 6.81413L0.0723877 2.96357ZM11.3237 8.2168C10.321 9.03329 9.83041 10.1972 9.83041 11.3646L9.36845 11.361C8.91722 11.361 8.69161 11.9089 9.01033 12.2277L10.296 13.5133C10.4929 13.7102 10.8152 13.7102 11.0122 13.5133L12.2978 12.2277C12.6165 11.9089 12.3873 11.3646 11.9361 11.3646L10.8546 11.3646C10.851 10.5875 11.1339 9.8104 11.7284 9.21593C13.0677 7.87659 15.3561 8.05207 16.4447 9.74236C17.0714 10.7057 17.0786 11.9949 16.4591 12.9654C15.6354 14.2617 14.1134 14.6807 12.8386 14.2152C12.6631 14.1543 12.4661 14.208 12.3336 14.3405C12.0686 14.6055 12.1725 15.0532 12.527 15.1785C13.9487 15.6834 15.5996 15.3719 16.742 14.2295C18.4358 12.5356 18.3141 9.72803 16.3803 8.18815C14.9192 7.02071 12.7705 7.03503 11.3237 8.2168Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendMail);
export default __webpack_public_path__ + "static/media/resend-mail.8ecda4a0adbbc2bc88c26cc8190edb88.svg";
export { ForwardRef as ReactComponent };